import React from 'react'
import {LoadMore} from 'react-weui';

class Infinite extends React.Component {
    static defaultProps = {
        distance: 200
    }
    constructor(props) {
        super(props)
        this.handleScroll = this.handleScroll.bind(this)
        this.el = props.el || window
    }
    componentDidMount() {
        this.el.addEventListener('scroll', this.handleScroll)
    }
    componentWillUnmount() {
        this.el.removeEventListener('scroll', this.handleScroll)
    }
    handleScroll() {
        if (this.props.isStop) {
            return
        }
        if (this.isTouchBottom()) {
            this.props.onTouchBottom()
        }
    }
    getScrollTop() {
        if (this.el === window) {
            return document.body.scrollTop || document.documentElement.scrollTop
        } else {
            return this.el.scrollTop
        }
    }
    getScrollHeight() {
        if (this.el === window) {
            return document.body.scrollHeight || document.documentElement.scrollHeight
        } else {
            return this.el.scrollHeight
        }
    }
    getWindowHeight() {
        if (this.el === window) {
            return document.documentElement.clientHeight
        } else {
            return this.el.getBoundingClientRect().height
        }
    }
    isTouchBottom() {
        const distance = this.props.distance
        return this.getScrollTop() + this.getWindowHeight() + distance >= this.getScrollHeight()
    }
    renderLoading () {
        return (
            <div className="wk-infinite-loader wk-border-line-after">
                { (!this.props.isKill && this.props.isStop) && <LoadMore loading>加载中...</LoadMore> }
                { this.props.isKill && <LoadMore showLine>没有更多了</LoadMore> }
            </div>
        )
    }
    render() {
        return (
            this.props.isShowLoading ? this.renderLoading() : null
        )
    }
}

export default function (props) {
    if (props.isShowLoading && !props.isKill) {
        return <Infinite {...props} />
    }
    if (props.isKill) {
        return null
    } else {
        return <Infinite {...props} />
    }
}

/*

<WKInfiniteScroll 
    onTouchBottom={() => this.handleTouchBottom()} // 到达底部执行的方法
    isStop={false} // 暂停执行onTouchBottom，一般是正在请求接口时触发
    distance={300} // 距离底部多少px触发
    isKill={false} // 不再监听滚动，一般是传!has_more 
    isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
/>

// 若针对div的滚动，可以传div进el，没有el默认是window滚动

<WKInfiniteScroll 
    onTouchBottom={() => this.handleTouchBottom()} // 到达底部执行的方法
    isStop={false} // 暂停执行onTouchBottom，一般是正在请求接口时触发
    distance={300} // 距离底部多少px触发
    isKill={false} // 不再监听滚动，一般是传!has_more
    isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
    el={this.dom}
/>

*/


// WEBPACK FOOTER //
// ./src/components/wk/WKInfiniteScroll.js